import { render } from "./ModalContentOpportunity.vue?vue&type=template&id=619a675f&lang=true"
import script from "./ModalContentOpportunity.vue?vue&type=script&lang=js"
export * from "./ModalContentOpportunity.vue?vue&type=script&lang=js"
script.render = render

export default script